<template>
    <div>
        <div class="conheca-vantagens-content">
            <h1>Conheça as <strong>Vantagens</strong></h1>
            <div class="vantagens-content">
                <img class="vantagens-banner" src="@/assets/imgs/conheca-vantagens-banner.png" />
                <div class="vantagens-texto">
                    <div class="vantange-texto-linha">
                        <img class="seta" src="@/assets/imgs/svg/arrow_home_consulta.svg" />
                        <h4>Consulta on-line e gratuita</h4>
                    </div>
                    <div class="vantange-texto-linha">
                        <img class="seta" src="@/assets/imgs/svg/arrow_home_consulta.svg" />
                        <h4>Mais de 60% das dívidas recuperadas em até 3 dias úteis</h4>
                    </div>
                    <div class="vantange-texto-linha">
                        <img class="seta" src="@/assets/imgs/svg/arrow_home_consulta.svg" />
                        <h4>Entenda o Mercado</h4>
                    </div>
                    <div class="vantange-texto-linha">
                        <img class="seta" src="@/assets/imgs/svg/arrow_home_consulta.svg" />
                        <h4>Segurança jurídica em todas as etapas do processo</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        home: Boolean,
    },
    data() {
      return {
        mobile: window.innerWidth < 1200,
        vantagensIconProperties: {
            center: true,
            rounded: 'circle',
            fluidGrow: true,
            height: (this.home? 50 : 68),
            width: (this.home? 50 : 68)
        },
        vantagemCards: [
            {
                cardClass: 'card-browser',
                cardText: `Consulta on-line
                e gratuita`,
                cardImgSrc: 'browser@2x.png',
                cardTitleLong:'Consulta on-line e gratuita',
                cardTextLong: 'Descubra com nossos experts como aumentar<br>os resultados da sua empresa.O melhor de<br>tudo? <b>A consulta é gratuita.</b>',
                cardTextLongMobile: 'Descubra com nossos experts<br>como aumentar os resultados<br>da sua empresa. O melhor de<br>tudo? <b>A consulta é gratuita.</b>',
            },
            {
                cardClass: 'card-deposit',
                cardText: `Entenda o
                seu Mercado`,
                cardImgSrc: 'deposit@2x.png',
                cardTitleLong:'Entenda o seu Mercado',
                cardTextLong: 'Somente com os cartórios de protesto sua<br>dívida é cobrada sem custo',
                cardTextLongMobile: 'Somente com os cartórios de<br>protesto sua dívida é cobrada<br>sem custo',
            }, 
            {
                cardClass: 'card-money-bag',
                cardText: `Mais de 60% das dívidas
                recuperadas em até 3
                dias úteis`,
                cardImgSrc: 'money-bag@2x.png',
                cardTitleLong: `Mais de 60% das dívidas
                recuperadas em até 3 dias úteis`,
                cardTextLong: '45 bilhões de títulos privados foram recuperados<br>pelos Cartórios de Protesto nos últimos 30 meses',
                cardTextLongMobile: '45 bilhões de títulos privados<br>foram recuperados pelos<br>Cartórios de Protesto nos últimos<br>30 meses',
            }, 
            {
                cardClass: 'card-web-browser',
                cardText: `Segurança jurídica
                em todas as etapas
                do processo`,
                cardImgSrc: 'web-browser@2x.png',
                cardTitleLong: `Segurança jurídica em todas
                as etapas do processo`,
                cardTextLong: 'Aproveite a segurança durante todo processo<br>para otimizar seu planejamento financeiro',
                cardTextLongMobile: 'Aproveite a segurança durante<br>todo processo para otimizar seu<br>planejamento financeiro',
            }
        ],
        saibaMaisIconProperties: {
            style: {
                height: '20px',
                width: '20px',
            }
        },
      }
    },
    methods: {
        getVantagensIcon(imageSrc) {
            var images = require.context('../../assets/imgs/', false, /.png$/);
            return images('./' + imageSrc)
        },
    }
}
</script>
<style scoped>
    #conheca-vantagens{width: 100%;background:#EFF2F5;height: fit-content;padding: 221px 0 171px 0;display:flex;justify-content: center;}
        #conheca-vantagens .conheca-vantagens-content{width: 100%;max-width:1126px;display: flex;flex-flow: column;}
            #conheca-vantagens h1{
                text-align: center;
                font-family: 'Kanit', sans-serif;
                font-size: 50px;
                line-height: 77px;
                font-weight: 100;
                letter-spacing: -1%;
                color:var(--secondary-color);
                text-transform: none;  
                margin-bottom: 122px;  
            }
            #conheca-vantagens h1 strong{
                font-weight: 400;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content {
                display: flex;
                gap: calc(86px + 23px + 52px);
                flex-wrap: wrap;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-banner {
                width: 477px;
                height: 539px;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto {
                display: flex;
                flex-flow: column;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha {
                display: flex;
                width: 451px;
                flex-flow: column;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha:not(:last-child):after {
                content: '';
                width: calc(100% - 9px);
                height: 1px;
                background-color: var(--dark-gray-color);
                display: flex;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha .seta{
                display: flex;
                width: 23px;
                height: 20px;
                position: absolute;
                margin-top: 44px;
                margin-left: -52px;
            }
            #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha h4{
                font-family: 'Kanit', sans-serif;
                font-size: 32px;
                line-height: 50px;
                font-weight: 300;
                letter-spacing: 0%;
                color:var(--secondary-color);
                text-transform: none;
                margin: 29px 0px;
            }
            
@media (max-width: 1200px){
    #conheca-vantagens {padding-top:163px;}
    #conheca-vantagens h1 {margin-bottom: 75px;}
    #conheca-vantagens .conheca-vantagens-content{max-width:unset; padding: 0 40px;}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content{justify-content: center;gap: 50px;}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha{margin-left: calc(52px + 23px);}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha h4{font-size: 20px;line-height: 24px;}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha .seta{margin-top: 32px;margin-left: -42px;}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-banner {max-width: 100%;height: auto;}
}
@media (max-width: 600px){
    #conheca-vantagens h1{line-height: 60px; margin-bottom: 75px;}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto{width: 100%;}
    #conheca-vantagens .conheca-vantagens-content .vantagens-content .vantagens-texto .vantange-texto-linha{width: calc(100% - 30px);margin-left: auto;}
}
</style>